import APICaller from '../library/APICaller'

const CustomerServices = {
  /**
   * 고객리스트(로그인 사용자의 권한/이메일/회사코드)
   * @return {Promise}
   */
  getCustomers (email) {
    return APICaller.get('/api/v1/customers', {email : email})
  },
  /**
   * 고객 전체 리스트 + 베스핀 글로벌
   * @return {Promise}
   */
  getCustomersBespin () {
    return APICaller.get('/api/v1/customers/bespin')
  },
  /**
   * 회사코드로 Sale 목록 조회
   * @return {Promise}
   */
  getCustomersCompanySaleslist () {
    return APICaller.get('/api/v1/customers/company/sales-list')
  },
  /**
   * 회사코드로 고객 목록 조회
   * @return {Promise}
   */
  getCustomersCompanys () {
    return APICaller.get('/api/v1/customers/companys')
  },

  getCustomersCompanysList () {
    return APICaller.get('/api/v1/customers/companysList')
  },
  /**
   * 부서별 매출
   * @param  {String} deptCode 부서코드
   * @param  {String} params.endMonth 종료월
   * @param  {String} params.startMonth 시작월
   * @return {Promise}
   */
  getCustomersDeptsSalesWithDepthCode (deptCode, { endMonth, startMonth }) {
    return APICaller.get(`/api/v1/customers/depts/${deptCode}/sales`, {
      endMonth, startMonth, deptCode
    })
  },
  /**
   * GroupId로 영업담당자 조회
   */
  getCustomersGroups () {
    return APICaller.get(`/api/v1/customers/groups`)
  },
  /**
   * PA 외 기타 페르소나 고객 목록에서 사용자 정보 조회
   * @return {Promise}
   */
   getCustomerUsers () {
    return APICaller.get(`/api/v1/customers/users`)
  },
  /**
   * 담당자가 이메일로 고객사 정보 조회
   * @param  {String} userEmail
   * @return {Promise}
   */
  getCustomerPersoninChargeWithUseremail (userEmail) {
    return APICaller.get(`/api/v1/customers/person-in-charge/${userEmail}`, {
      userEmail
    })
  },
  /**
   * Sale 리스트(로그인 사용자 권한별(Auth))
   * @return {Promise}
   */
  getCustomersSales () {
    return APICaller.get('/api/v1/customers/sales')
  },
  /**
   * 고객 등록
   * @param  {String} params.companyCode
   * @param  {String} params.customerCode
   * @param  {String} params.customerDeptCode
   * @param  {String} params.customerDeptName
   * @param  {String} params.customerName
   * @param  {String} params.desc
   * @param  {String} params.remark
   * @param  {String} params.userEmail
   * @param  {String} params.userId
   * @param  {String} params.userName
   * @return {Promise}
   */
  postCustomersSales ({ companyCode, customerCode, customerDeptCode, customerDeptName, customerName, desc, remark, userEmail, userId, userName }) {
    return APICaller.post('/api/v1/customers/sales', {
      companyCode, customerCode, customerDeptCode, customerDeptName, customerName, desc, remark, userEmail, userId, userName
    })
  },
  getCustomersContract({customerCode,customerDeptCode,companyCode}) {
    return APICaller.get(`/api/v1/customers/customerContract`, {
      customerCode,customerDeptCode,companyCode
    })

  },
  insertCustomerContract({contractCode, customerCode, customerDeptCode, companyCode}) {
    return APICaller.post(`/api/v1/customers/insertCustomerContractPrev`, {
      contractCode, customerCode, customerDeptCode, companyCode
    })
  },

  getCustomerContractPrev({customerCode,customerDeptCode,companyCode}) {

    return APICaller.get(`/api/v1/customers/customerContractListPrev`, {
      customerCode,customerDeptCode,companyCode
    })

  },

  deleteCustomerContractPrev (customerCode, customerDeptCode,companyCode,contractCode) {

    return APICaller.get(`/api/v1/customers/deleteCustomerContractPrev`, {
      customerCode, customerDeptCode,companyCode,contractCode
    })
  },
  getCustomerContractList({customerCode,customerDeptCode,companyCode,userEmail}) {

    return APICaller.get(`/api/v1/customers/customerContractList`, {
      customerCode,customerDeptCode,companyCode,userEmail
    })

  },

  getCustomerContract({customerCode,customerDeptCode,companyCode,userEmail}) {

    return APICaller.get(`/api/v1/customers/customerContractsList`, {
      customerCode,customerDeptCode,companyCode,userEmail
    })

  },

  insertCustomerContractList({popupStr, customerCode, customerDeptCode, companyCode,userEmail}) {

    return APICaller.post(`/api/v1/customers/insertCustomerContractList`, {
      popupStr, customerCode, customerDeptCode, companyCode,userEmail
    })
  },
  deleteCustomerContractList (contractCode,customerCode, customerDeptCode,companyCode,userEmail) {

    return APICaller.get(`/api/v1/customers/deleteCustomerContractList`, {
      contractCode,customerCode, customerDeptCode,companyCode,userEmail
    })
  },
  getCustomersAllList () {
    return APICaller.get(`/api/v1/customers/all`)
  }
}

export default CustomerServices



// WEBPACK FOOTER //
// ./src/services/CustomerServices.js